import styled from 'styled-components';

export const ParentAccountReportingWrapper = styled.div`
 display: flex;
`;
